import { Badge, Inline, Stack } from '@amboss/design-system';
import { useFormikContext } from 'formik';
import moment from 'moment/moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useBottomModal from '../../../../hooks/useBottomModal';
import type { Credits } from '../../../../interfaces/credits';
import EmptyPlaceholder from '../../../atoms/EmptyPlaceholder';
import ItemCourse from '../../../atoms/ItemCourse';
import ItemDate from '../../../atoms/ItemDate';
import TabList from '../tabs/TabList';

declare type ReviewFormProps = {
  credits: Credits | undefined;
};

const CourseReviewedList = ({ credits }: ReviewFormProps) => {
  const { t } = useTranslation();
  const { setBottomModalForm, creditIds } = useBottomModal();
  const { setFieldValue } = useFormikContext();

  const baseCreditIds = credits?.items.map((c) => ({ checked: false, ...c }));
  const [selectedCourseIds, setSelectedCourseIds] = useState<any[]>(baseCreditIds || []);

  useEffect(() => {
    setFieldValue('creditIds', creditIds);
  }, [creditIds, setFieldValue]);

  const checkItemHandler = (itemIds: string[], itemCredits: number) => {
    setBottomModalForm({
      selectedCount: itemCredits,
      creditIds: itemIds,
    });
  };

  const formattedCompletedAtDate = (completedAtDate: string) => {
    return moment(completedAtDate).format('MMM D, YYYY');
  };

  const centerItemElement = (item: any) => {
    return (
      <ItemCourse
        courseId={item._id || ''}
        courseTitle={item._courseTitle}
        courseSubtitle={item._courseSubtitle}
        parsStatus={item._status}
        parsResponse={item._parsResponse}
      />
    );
  };

  const onSelectElementUpdateChecked = (currentItemId: string) => {
    const updatedItems = selectedCourseIds.map((item) => {
      return {
        ...item,
        checked: item._id === currentItemId,
      };
    });

    setSelectedCourseIds(updatedItems);
  };
  const showEmptyPlaceholder = selectedCourseIds?.length === 0;

  return (
    <Stack space={'m'}>
      {showEmptyPlaceholder && (
        <EmptyPlaceholder header={t('credits.tabs.tab2.emptyPlaceholder.header')} />
      )}

      {selectedCourseIds?.map((item, i) => {
        const creditValue = item?._courseCmeCredits || 0;

        return (
          <TabList
            key={item._id}
            left={
              <ItemDate
                date={formattedCompletedAtDate(item._completedAt)}
                checked={item.checked}
                onCheck={() => {
                  const candidateIds = [item._id || item.id].filter(Boolean);
                  onSelectElementUpdateChecked(item._id);
                  checkItemHandler(candidateIds, creditValue);
                }}
              />
            }
            center={centerItemElement(item)}
            right={
              <Inline alignItems={'right'}>
                <Badge
                  color={'brand'}
                  text={t('credits.tabs.tab2.listItem.badge', {
                    count: creditValue,
                    type: 'CREDIT',
                  })}
                />
              </Inline>
            }
            isLastItem={selectedCourseIds.length - 1 === i}
          />
        );
      })}
    </Stack>
  );
};

export default CourseReviewedList;
